import { TokenModel } from '@/shared/domain/TokenModel'
import { IFeesController, commissionByUserGetter, dataToAddUserToBrand, dataToGenerateCommission, dataToGetCommissionByUser, dataToGetInvoices, dataToGetPartnerCategories, dataToGetUserPartners, dataToPayCommissionByUser, dataToRemoveUserFromBrand, datatoCreateDailyContactV2, datatoCreatePlanV2, datatoCreateProducttV2, datatoUpdateDailyContactV2, datatoUpdatePlanV2, datatoUpdateProductV2, invoicesrGetter, partnerCategoriesGetter, userPartnerGetter } from '../../domain/FeesController'
import FeesRepository from '../repository/Fees.repository'
// import { commissionByUserGetter } from '../../domain/models/CommissionByUser'

export default class FeesController implements IFeesController {
  repository: FeesRepository

  constructor () {
    this.repository = new FeesRepository()
  }

  async getUserPartners (data: dataToGetUserPartners): Promise<userPartnerGetter> {
    const response = await this.repository.getUserPartners(data)
    return { data: response?.data, status: response?.status }
  }

  async getPartnerCategories (data: dataToGetPartnerCategories): Promise<partnerCategoriesGetter> {
    const response = await this.repository.getPartnerCategories(data)
    return { data: response?.data, status: response?.status }
  }

  async addUserToBrand (data: dataToAddUserToBrand): Promise<boolean> {
    const response = await this.repository.addUserToBrand(data)
    return response
  }

  async removeUserFromBrand (data: dataToRemoveUserFromBrand): Promise<boolean> {
    const response = await this.repository.removeUserFromBrand(data)
    return response
  }

  async getFeesData (data: TokenModel): Promise<userPartnerGetter> {
    const response = await this.repository.getFeesData(data)
    return { data: response?.data, status: response?.status }
  }

  async getInvoices (data: dataToGetInvoices): Promise<invoicesrGetter> {
    const response = await this.repository.getInvoices(data)
    return { data: response?.data, status: response?.status }
  }

  async getCommissionByUser (data: dataToGetCommissionByUser): Promise<commissionByUserGetter> {
    const response = await this.repository.getCommissionByUser(data)
    return response
  }

  async getCommissionByUserCsv (data: dataToGetCommissionByUser): Promise<commissionByUserGetter> {
    const response = await this.repository.getCommissionByUserCsv(data)
    return response
  }

  async payCommissionByUser (data: dataToPayCommissionByUser): Promise<commissionByUserGetter> {
    const response = await this.repository.payCommissionByUser(data)
    return response
  }

  async generateCommission (data: dataToGenerateCommission): Promise<commissionByUserGetter> {
    const response = await this.repository.generateCommission(data)
    return response
  }

  async getPlansV2 (data: TokenModel): Promise<invoicesrGetter> {
    const response = await this.repository.getPlansV2(data)
    return response
  }

  async postPlansV2 (data: datatoCreatePlanV2): Promise<invoicesrGetter> {
    const response = await this.repository.postPlansV2(data)
    return response
  }

  async patchPlansV2 (data: datatoUpdatePlanV2): Promise<invoicesrGetter> {
    const response = await this.repository.patchPlansV2(data)
    return response
  }

  async getDailyContactV2 (data: TokenModel): Promise<invoicesrGetter> {
    const response = await this.repository.getDailyContactV2(data)
    return response
  }

  async postDailyContactV2 (data: datatoCreateDailyContactV2): Promise<invoicesrGetter> {
    const response = await this.repository.postDailyContactV2(data)
    return response
  }

  async patchDailyContactV2 (data: datatoUpdateDailyContactV2): Promise<invoicesrGetter> {
    const response = await this.repository.patchDailyContactV2(data)
    return response
  }

  async getProductsV2 (data: TokenModel): Promise<invoicesrGetter> {
    const response = await this.repository.getProductsV2(data)
    return response
  }

  async postProductsV2 (data: datatoCreateProducttV2): Promise<invoicesrGetter> {
    const response = await this.repository.postProductsV2(data)
    return response
  }

  async patchProductsV2 (data: datatoUpdateProductV2): Promise<invoicesrGetter> {
    const response = await this.repository.patchProductsV2(data)
    return response
  }

  async getCountryV2 (data: TokenModel): Promise<invoicesrGetter> {
    const response = await this.repository.getCountryV2(data)
    return response
  }
}
